export const defaultStyle = {
  blockSlide:
    " pr-30 md:px-[25px] w-full inline-block border-r-0 md:border-r-1",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: "font-Regular font-normal tracking-[0.53px] text-black",
  blockSlider: "max-w-lg mx-auto mb-[50px]",
  heading: "text-orange text-[60px] font-MDLZBiteType text-purple mb-[80px]",
  btnWrpr: "text-red",
  prevArrow: "bg-red",
}

export const TEXT_CARDS = {
  blockSlide:
    "draggableSlide  md:px-[25px] lg:px-[35px] w-full inline-block md:min-h-[280px]",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: "font-Regular font-normal tracking-[0.53px] text-black",
  blockSlider: "blockSliderContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[15px] lg:px-[60px] pt-[50px] mb-[50px]",
  heading: " text-[60px] font-MDLZBiteType text-purple mb-[80px]",
  blockSliderWrapper: "blockSliderWrapper md:mr-[3px] max-[767px]:px-[35px] textCardsWrapper",
  blockSlideWrpr: "blockSlideWrpr border-r-0 md:border-r-1",
  cardTag: "text-[14px] font-Bold"
}

export const NEWS_STORY_CARDS = {
  blockSlide: "newsDraggable",
  blockSlider:
    "imageSliderContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto mb-[50px] pt-[45px] pb-[50px] px-[35px] md:px-[60px]",
  heading:
    " text-[36px] px-[20px] md:px-[0px] md:text-[60px] text-purple font-MDLZBiteType mb-[60px] md:mb-[80px]",
  btnContainer: "pt-[80px] text-center",
  btnWrpr:
    " font-bold inline-block py-[20px] px-[45px] border-2 border-solid border-purple rounded-[40px] uppercase text-[21px] text-center leading-[21px] tracking-[2.2px] duration-500 font-Regular bg-purple hover:bg-[#724D8D] hover:border-[#724D8D] text-white",
}


export const BLOCK_SLIDER_WITH_HIGHLIGHTS = {
  blockSlide:
    "draggableSlide  w-full inline-block  ",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: " highlight-desc font-Regular text-[21px] font-normal leading-[31.5px] tracking-[0.53px] text-black  px-[35px] md:px-[15px]",
  blockSlider: " blockSlider-container pb-[45px] blockSlider-container_highlight md:max-w-md lg:max-w-lg xl:max-w-xl mb-[50px] mx-auto mt-[40px] md:mt-0",
  heading: "text-green font-Light mb-[35px] md:leading-[57.6px] leading-[28.8px] text-[24px] tracking-normal md:text-[48px] px-[35px] md:px-[15px]",
  blockSliderWrapper: "pt-[45px] max-[767px]:pl-[35px] max-[767px]:border-b-1 max-[767px]:border-[#666]"

}

export const JOB_SLIDER = {
  blockSlide:
    "draggableSlide jobSlide blockSlider-JOb w-full inline-block  ",
  btnWrpr: "btnWrpr imageLinkTwo font-Light font-[300] text-green text-[18px] md:text-[30px] flex mb-[8px] tracking-normal leading-[21.6px] md:leading-[36px] event_internal_link",
  btnContainer: "purple-button [&>a]:bg-purple flex [&>a]:text-center [&>a]:text-[14px] [&>a]:lg:text-[21px] [&>a]:transition-all [&>a]:leading-[21px] [&>a]:duration-[.5s] [&>a]:tracking-[2.8px] [&>a]:lg:tracking-[4.2px] [&>a]:uppercase [&>a]:border-[2px] [&>a]:border-purple [&>a]:text-white [&>a]:hover:bg-lightpurple [&>a]:hover:border-lightpurple [&>a]:font-Bold [&>a]:px-[45px] [&>a]:py-[20px] [&>a]:rounded-[40px] [&>a]:mx-auto [&>a]:mt-[35px] [&>a]:lg:mt-[150px]",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: " highlight-desc font-Regular text-[21px] font-normal leading-[31.5px] tracking-[0.53px] text-black  px-[35px] md:px-[15px]",
  blockSlider: " blockSlider-container pb-[45px]  blockSlider-JOb md:max-w-md lg:max-w-lg xl:max-w-xl mb-[50px] mx-auto px-[35px] md:px-[15px] lg:px-[15px]",
  heading: "text-purple heading-title font-MDLZBiteType mb-[40px] md:mb-[65px] md:leading-[72px] leading-[43.2px] text-[36px] tracking-normal md:text-[60px]",
  blockSliderWrapper: "pt-[45px] pt-[0px] max-[767px]:pl-[0px] max-[767px]:border-b-1 max-[767px]:border-[#666]"
}
export const PRESS_CARD = {
  blockSliderFullBG: 'blockSliderFullBG bg-[#f8f8f8]',
  blockSlide:
    "draggableSlide  w-full inline-block  ",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: " highlight-desc font-Regular text-[21px] font-normal leading-[31.5px] tracking-[0.53px] text-black  px-[35px] md:px-[15px]",
  blockSlider: " py-[60px] md:py-[90px] blockSlider-press md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[0px]",
  heading: "text-purple heading-title font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
  blockSliderWrapper: "max-[767px]:pl-[35px] md:px-[45px] max-[767px]:mr-[-2px] max-[767px]:border-b-1 max-[767px]:border-[#666]",
  btnContainer: "purple-button [&>a]:bg-purple flex [&>a]:text-center [&>a]:text-[14px] [&>a]:lg:text-[21px] [&>a]:transition-all [&>a]:leading-[21px] [&>a]:duration-[.5s] [&>a]:tracking-[2.8px] [&>a]:lg:tracking-[4.2px] [&>a]:uppercase [&>a]:border-[2px] [&>a]:border-purple [&>a]:text-white [&>a]:hover:bg-lightpurple [&>a]:hover:border-lightpurple [&>a]:font-Bold [&>a]:px-[45px] [&>a]:py-[20px] [&>a]:rounded-[40px] [&>a]:mx-auto [&>a]:mt-[60px] [&>a]:md:mt-[90px]",
}

export const PRESS_CARD_WITH_WHITE_BG = {
  ...PRESS_CARD,
  blockSliderFullBG: 'blockSliderFullBG bg-white',
}

export const CONTACT_CARD = {
  blockSlide:
    "draggableSlide  w-full inline-block  ",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Light text-green mb-[30px] leading-[28.8px] md:leading-[57.6px] px-[35px] md:px-[15px]",
  description: " highlight-desc font-Regular text-[21px] font-normal leading-[31.5px] tracking-[0.53px] text-black  px-[35px] md:px-[15px]",
  blockSlider: " py-[30px] md:py-[45px] mb-[70px] md:mb-[90px] blockSlider-press  md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[0px]",
  heading: "text-purple heading-title font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
  blockSliderWrapper: "max-[767px]:pl-[35px] md:px-[45px] max-[767px]:border-b-1 max-[767px]:border-[#666]",
  btnContainer: "purple-button [&>a]:bg-purple flex [&>a]:text-center [&>a]:text-[14px] [&>a]:lg:text-[21px] [&>a]:transition-all [&>a]:leading-[21px] [&>a]:duration-[.5s] [&>a]:tracking-[2.8px] [&>a]:lg:tracking-[4.2px] [&>a]:uppercase [&>a]:border-[2px] [&>a]:border-purple [&>a]:text-white [&>a]:hover:bg-lightpurple [&>a]:hover:border-lightpurple [&>a]:font-Bold [&>a]:px-[45px] [&>a]:py-[20px] [&>a]:rounded-[40px] [&>a]:mx-auto [&>a]:mt-[60px] [&>a]:md:mt-[90px]",

}
export const OVERVIEW_CARD ={
  ...CONTACT_CARD,
  heading: "text-purple heading-title font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
  blockSlider: " py-[30px] md:py-[45px] mb-[70px] md:mb-[90px] blockSlider-press  md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[0px]",

}
export const CONTACT_CARD_WITH_BG = {
  ...CONTACT_CARD,
  blockSliderFullBG:"blockSliderFullBG bg-grayWhite contactcardWithBG",
  blockSliderWrapper: "max-[767px]:pl-[35px] max-[767px]:border-b-1 max-[767px]:border-[#666] md:px-[45px]",
  subHeading:"subHeading text-[24px] not-italic md:text-[48px] font-light font-Light text-green mb-[30px] tracking-normal leading-[28.8px] md:leading-[57.6px]",
  blockSlider:"Slider py-[30px] md:py-[45px] mb-[70px] blockSlider-press  md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto ",
  description: " highlight-desc font-Regular text-[14px] md:text-[21px] font-normal leading-[21px] md:leading-[31.5px] tracking-[0.53px] text-black ",
  heading: "text-purple font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
}

export const ONLY_IMAGE_CARD = {
  blockSlide:
    "draggableSlide  w-full inline-block  ",
  subHeading:
    "text-[24px] md:text-[48px] font-light font-Regular text-green mb-[30px]",
  description: " highlight-desc font-Regular text-[21px] font-normal leading-[31.5px] tracking-[0.53px] text-black  px-[35px] md:px-[15px]",
  blockSlider: " py-[30px] md:py-[45px] mb-70px md:mb-[90px] blockSlider-press blockSlider-image md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[15px]",
  heading: "text-purple font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
  blockSliderWrapper: "max-[767px]:pl-[35px] max-[767px]:border-b-1 max-[767px]:border-[#666] onlyImageCard",
  btnContainer: "purple-button [&>a]:bg-purple flex [&>a]:text-center [&>a]:text-[14px] [&>a]:lg:text-[21px] [&>a]:transition-all [&>a]:leading-[21px] [&>a]:duration-[.5s] [&>a]:tracking-[2.8px] [&>a]:lg:tracking-[4.2px] [&>a]:uppercase [&>a]:border-[2px] [&>a]:border-purple [&>a]:text-white [&>a]:hover:bg-lightpurple [&>a]:hover:border-lightpurple [&>a]:font-Bold [&>a]:px-[45px] [&>a]:py-[20px] [&>a]:rounded-[40px] [&>a]:mx-auto [&>a]:mt-[60px] [&>a]:md:mt-[90px]",
}
export const ONLY_TWO_IMAGE_CARD = {
  ...ONLY_IMAGE_CARD,
}

export const TWO_IMAGE_CARD_COUNTRY_NEW = {
  ...ONLY_IMAGE_CARD,
  heading: "text-green font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
}

export const PRODUCT_SLIDER = {
  blockSliderFullBG: 'blockSliderFullBG bg-grayWhite',
  blockSlide:
    "draggableSlide  w-full inline-block  ",
  subHeading:
    "",
  description: " highlight-desc",
  blockSlider: "md:py-0 blockSlider-press md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[15px]",
  heading: "heading",
  blockSliderWrapper: "max-[767px]:pl-[35px] ",
  btnContainer: "purple-button ",
}

export const STOCK_SLIDER= {
  ...defaultStyle,
  blockSlider: "mx-auto mb-[50px] py-[30px] lg:py-[50px] lg:mb-0 bg-[#FAFAFA]",
  heading: "text-purple font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
}

export const AWARD_CARD_SLIDER = {
  blockSliderFullBG: "bg-[#4F2170] pt-60 pb-60 award-card-slider relative",
  blockSlideWrpr: "!block h-full",
  blockSlide: "h-full items-center",
  subHeading: "title text-[26px] leading-[31.2px] font-bold text-center mt-[24px] mb-10 uppercase text-white",
  description: "sub-title font-BwSurco text-[20px] leading-[24px] leading-[31.2px] w-full text-center px-20 text-white",
  blockSlider: "blockSlider-award blockSlider-image lg:max-w-lg xl:max-w-[1196px] mx-auto",
  heading: "text-white font-MDLZBiteType text-[48px] leading-[57.6px] text-center",
  blockSliderWrapper: "px-20 lg:px-0 onlyImageCard",
  btnContainer: "text-center mt-[120px]",
  btnWrpr: "bg-Bisque text-[18px] leading-[27px] font-BwSurcoBold py-[16px] px-[32px] inline-block mx-auto rounded-full uppercase hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out",
  slickArrow : "slick-arrow",
  imageWrapperLarge: "absolute z-20 left-0 top-[-110px] md:top-[-75px]",
  imageWrapperMedium: "absolute z-10 left-auto right-0 top-[-120px]",
}

export const OTHER_INITIATIVES_SLIDER = {
  blockSliderFullBG: "bg-[#FDC583] pt-40 pb-[150px] lg:pb-80 our-initiatives relative",
  blockSlideWrpr: "!block h-full rounded-[10px] overflow-hidden",
  blockSlide: "h-full items-center p-16 bg-white",
  imgWrapper: "overflow-hidden  rounded-[10px]",
  subHeading: "text-26 leading-[31.2px] font-bold text-center mt-16 min-h-[72px]",
  description: " ",
  blockSlider: "lg:max-w-lg xl:max-w-[1052px] mx-auto px-20 lg:px-0",
  heading: "text-purple font-MDLZBiteType text-[60px] leading:[72px] lg:text-[72px] lg:leading:[86.4px] text-center mb-[40px]",
  blockSliderWrapper: "",
  btnContainer: "btnContainer absolute bottom-100 lg:bottom-80 right-12 lg:right-32",
  btnWrpr: "",
  slickArrow : "",
  imageWrapper: "",
  imageWrapperLarge: "absolute z-10 left-auto right-0 top-[-125px]",
  imageWrapperMedium: "absolute z-10 left-auto right-0 top-[-120px]",
}

export const SUSTAINABLE_COCOA_LIFE_FARMING = {
  blockSliderFullBG: "bg-[#FDC583] relative section-sustainable pt-60 mt-[-2px]",
  blockSlideWrpr: "!block h-full",
  blockSlider: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  blockSlide: "h-full flex flex-wrap justify-between relative lg:pb-[48px]",
  imgWrapper: "w-full lg:w-[38%] col-left mb-[16px] lg:mb-0",
  descriptionWrapper: "w-full lg:w-[58.5%] col-right static xl:relative top-[25px] mb-80 lg:mb-0",
  subHeading: "font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16 tracking-normal",
  description: "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-40 [&>p>strong]:text-center",
  heading: "text-purple font-MDLZBiteType text-[60px] lg:text-[72px] leading:[72px] leading-[normal] text-center mb-[32px]",
  blockSliderWrapper: "",
  btnContainer: "btnContainer absolute bottom-100 lg:bottom-80 right-12 lg:right-32",
  btnWrpr: "",
  slickArrow : "",
  imageWrapperMedium: "absolute z-10 left-0 top-[-105px] w-[60%]",
  imageWrapperLarge: "absolute z-10 left-0 top-[-120px] w-[28%]",
}
export const RESTORING_FORESTS = {
  blockSliderFullBG: "section-protecting pt-80 lg:pt-60 mt-[-2px] bg-[#B5BF5E] relative",
  blockSlideWrpr: "!block h-full",
  blockSlider: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  blockSlide: "h-full flex flex-wrap lg:flex-row-reverse justify-between relative lg:pb-[48px]",
  imgWrapper: "w-full lg:w-[38%] col-left mb-[16px] lg:mb-0",
descriptionWrapper: "w-full lg:w-[58.5%] col-right static xl:relative top-[25px] mb-40 lg:mb-0",
  subHeading: "font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16 tracking-normal",
  description: "font-BwSurco text-[20px] leading-[24px] text-black text-left [&>p>strong]:block [&>p>strong]:mb-40 [&>p>strong]:text-[26px] [&>p>strong]:text-center [&>p]:tracking-normal mb-40",
  heading: "text-purple font-MDLZBiteType text-[60px] lg:text-[72px] leading:[72px] leading-[normal] text-center mb-[32px]",
  blockSliderWrapper: "",
  btnContainer: "btnContainer absolute bottom-100 lg:bottom-80 right-12 lg:right-32",
  btnWrpr: "",
  slickArrow : "",
  imageWrapperLarge: "absolute z-10 left-0 top-[-90px] w-[23%] lg:w-auto",
  imageWrapperMedium: "absolute z-10 right-0 lg:right-0 top-[56%] lg:top-[210px]",
}

export const COMMUNITY_INITIATIVES_SLIDER = {
  blockSliderFullBG: "bg-[#FAF3E7] pb-40 px-20 community-roadmap-section relative z-10",
  blockSlideWrpr: "!block h-full",
  blockSlide: "h-full items-center",
  subHeading: "text-26 leading-[31.2px] font-bold text-center mt-16 min-h-[72px]",
  description: " ",
  blockSlider: " mx-auto flex flex-col-reverse",
  heading: "text-purple font-MDLZBiteType text-[60px] leading:[72px] lg:text-[72px] lg:leading:[86.4px] text-center mb-[40px]",
  blockSliderWrapper: "",
  btnContainer: "btnContainer absolute bottom-100 lg:bottom-80 right-12 lg:right-32",
  btnWrpr: "",
  slickArrow : "",
}